import React, { Fragment, useEffect, useState } from 'react';
import { Form, Col, Row, Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  Button,
  CircularProgress,
  SvgIcon,
  StepConnector,
  makeStyles,
  withStyles,
  Step,
  StepLabel,
  alpha,
  Stepper,
  Slider,
  createTheme,
  ThemeProvider
} from "@material-ui/core";
import NumberFormat from 'react-number-format';
import DigitalCoverageAmounts from '../../../Helpers/Lists/CoverageAmounts/DigitalCoverageAmounts';
import ProductCoverageLength from '../../../Helpers/Lists/CoverageLengths/ProductCoverageLength';
import ShieldIcon from '../../../../icons/shield.svg';
import TimeIcon from '../../../../icons/time.svg';
import DollarIMacIcon from '../../../../icons/dollar-imac.svg';
import poorHealthIcon from '../../../../icons/poorHealth.svg';
import averageHealthIcon from '../../../../icons/averageHealth.svg';
import goodHealthIcon from '../../../../icons/goodHealth.svg';
import poorHealthIconWhite from '../../../../icons/poorHealthWhite.svg';
import averageHealthIconWhite from '../../../../icons/averageHealthWhite.svg';
import goodHealthIconColored from '../../../../icons/goodHealthColored.svg';
import {
  SESSION_STORAGE_TERM_STRUCTURE,
  getBasicInfo,
  setBasicInfo,
  setSessionStorageItem, SESSION_STORAGE_CUSTOMIZED_TEASER_KEY, removeSessionStorageItem,
} from '../../../../sessionStorage';
import Age from '../../../Helpers/Dates/Age';
import './PreQuote.scss';
import NeedsAnalysisButton from '../../../Tools/NeedsAnalysis/NeedsAnalysisButton';
import HealthClassCalcButton from '../HealthClassCalculator/HealthClassCalcButton';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonCheckedOutlined';
import RadioButtonUncheckedSharp from '@material-ui/icons/RadioButtonUncheckedSharp';
import clsx from 'clsx';
import TermLengthButton from '../TermLengthCalculator/TermLengthButton';
import { GetMCTQuotes } from '../Common/GetMCTQuotes';
import { NumberFormatDollars } from '../../../Helpers/Formatters';
import { TextInput } from '../../../Helpers/Inputs';
import { ContactSpecialist } from '../Common/ContactSpecialist';
import { getTermLengthFromAge } from '../../../Helpers/Lists/CoverageLengths/AmericoCoverageLengths';
import { getFaceAmountFromAge } from '../../../Helpers/Lists/CoverageAmounts/AmericoCoverageAmounts';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.primary.main,
  },
  backButton: {
    color: theme.palette.primary.main,
    background: "white"
  },
  amount: {
    color: theme.palette.primary.main
  },
  descBackground: {
    backgroundColor: alpha(theme.palette.primary.main, .1)
  },
  lightBackground: {
    backgroundColor: `${theme.palette.primary.main}16`,
  },
  primaryBackground: {
    backgroundColor: theme.palette.primary.main
  }
}));

const quoterTheme = {
  typography: {
    fontFamily: "museo-sans",
    body1: {
      fontSize: 14,
      fontWeight: 500,
    },
  },
  overrides: {
    MuiFormControl: {
      root: {
        "&.coverage-amount": {
          display: "flex",
          alignItems: "center",
        },
        "&.coverage-amount .coverage-input": {
          display: "flex",
          width: 188,
          height: 47,
          alignItems: "center",
          borderRadius: 6,

        },
        "&.coverage-amount .coverage-input::before": {
          content: "none",
        },
        "&.coverage-amount .coverage-input::after": {
          content: "none",
        },
        "&.coverage-amount .coverage-input input": {
          padding: 0,
        },
      },
    },

    MuiInputBase: {
      input: {
        fontSize: 16,
      },
      root: {
        height: 56,
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: "rgba(0, 0, 0, 0.05)",
      },
      underline: {
        "&::before": {
          borderBottom: "solid 2px #b2b2b2",
        },
        "&:hover::before": {
          borderBottomWidth: "2px",
        },
      },
    },
    MuiFormLabel: {
      root: {
        fontSize: 16,
        color: "rgba(0,0,0,0.6)",
      }
    },
    MuiFormHelperText: {
      root: {
        marginTop: 0,
        paddingTop: 0,
      },
    },
    MuiInputLabel: {
      shrink: {
        color: "rgba(0,0,0,0.3) !important",
      },
    },
    MuiSelect: {
      fontSize: 16,
      icon: {
        color: "rgba(0,0,0,1)"
      },
      iconFilled: {
        right: 16,
      },
    },
    MuiSlider: {
      root: {
        height: 4,
        margin: "8px 0",
        padding: 0,
      },
      rail: {
        height: 4,
        borderRadius: 2,
        backgroundColor: " #ccc",
        opacity: 1,
      },
      track: {
        height: 4,
        borderRadius: 2,
      },
      mark: {
        display: "none",
      },
      thumb: {
        marginTop: -4,
      },
      markLabel: {
        top: 9,
        fontSize: 12,
        color: "#333",
        "&[style*='0%;']": {
          "left": "0px !important",
          "transform": "translateX(0)",
        },
        "&[style*='100%;']": {
          "right": "0px !important",
          "left": "auto !important",
          "transform": "translateX(0)",
        },
      },
    },
    MuiSvgIcon: {
      root: {
        width: 24,
        height: 24,
        marginBottom: 1,
      },
      colorAction: {
        fill: "#b2b2b2",
      },
    },
    MuiPaper: {
      outlined: {
        border: "none",
        boxShadow: "0 2px 3px rgba(0, 0, 0, 0.161)",
      },
    },
  },
};

const HealthClassStepperConnector = withStyles({
  alternativeLabel: {
    top: 11,
    left: "calc(-60% + 19px)",
    right: "calc(40% + 19px)",
  },
  line: {
    height: 4,
    border: 0,
    backgroundColor: '#cccccc',
  },
})(StepConnector);

export default function PreQuote(props) {
  const basicInfoDetails = getBasicInfo();
  const termStructure = ['Level', 'Decreasing'];
  const [loading, setLoading] = useState(false);
  const [skipInitialQuoteRun, setSkipInitialQuoteRun] = useState(props.teaserRate && props.teaserRate > 0);
  const [lowestMonthlyQuote, setLowestMonthlyQuote] = useState(props.teaserRate || null);
  const [fullQuoteResults, setFullQuoteResults] = useState([]);
  const [multiTermResult, setMultiTermResult] = useState(false);
  const [calcHealthClass, setCalcHealthClass] = useState(null);
  const [activeTab, setActiveTab] = useState(props.formState.healthClass ? props.formState.healthClass === 'PP' ? 3 : props.formState.healthClass === 'P' ? 2 : 3 : 3);
  const [coverageAmount, setCoverageAmount] = useState(basicInfoDetails.faceAmount || parseInt(props.formState.coverageAmountQuote, 10));
  const classes = useStyles();

  useEffect(() => {
    props.onMultiTerm(multiTermResult);
    setSessionStorageItem(SESSION_STORAGE_TERM_STRUCTURE, { multiTerm: multiTermResult });
  }, [multiTermResult]);

  const CustomStepIcon = (props) => {
    const classes = useStyles();
    const { active } = props;
    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
        })}
      >
        {
          props.icon !== activeTab ?
            <RadioButtonUncheckedSharp htmlColor='#cccccc'/> :
            <RadioButtonCheckedIcon/>
        }
      </div>
    );
  };

  const setHealthClass = (tab) => {
    setActiveTab(tab);

    props.onFieldChange('healthClass', steps[tab - 1].healthValue);
  };

  const steps = [
    {
      label: "1",
      icon: activeTab === 1 ? poorHealthIconWhite : poorHealthIcon,
      healthValue: 'R',
      heading: "Some Health Issues",
      description: "Normal to below average height to weight ratio; may have moderate to significant health history, such as cancer, diabetes, COPD, heart disease or sleep apnea; and taking one or more medication(s). About 25% of all applicants have some health issues."
    },
    {
      label: "2",
      icon: activeTab === 2 ? averageHealthIconWhite : averageHealthIcon,
      healthValue: 'P',
      heading: "Good Health",
      description: "Good height and weight ratio – up to 10 lbs over ideal weight; blood pressure and cholesterol are normal and/or controlled; no diabetes or other chronic health concerns. About 25% of all applicants are in “Good” health."
    },
    {
      label: "3",
      icon: activeTab === 3 ? goodHealthIcon : goodHealthIconColored,
      healthValue: 'PP',
      heading: "Excellent Health",
      description: "Excellent height and weight ratio – not considered overweight; blood pressure and cholesterol levels are within ideal ranges; no financial, legal or health concerns. About 20% of all applicants are in “Excellent” health."
    }
  ];

  const runQuote = (getIsSubscribed) => {
    GetMCTQuotes(props.basicInfo, props.formState.healthClass, coverageAmount, props.formState.termQuote, setLoading, getIsSubscribed, setMultiTermResult, setQuoteResults, termStructure, false, null, false, true);
  };

  const setQuoteResults = (quoteResults) => {
    if (quoteResults.length === 0) {
      setLowestMonthlyQuote(undefined);
    }
    else {
      setLowestMonthlyQuote(quoteResults[0].monthlyRate);
    }
    setFullQuoteResults(quoteResults);
  };

  let debounce = null;
  useEffect(() => {
    if (skipInitialQuoteRun) {
      setSkipInitialQuoteRun(false);
      removeSessionStorageItem(SESSION_STORAGE_CUSTOMIZED_TEASER_KEY);
      return;
    }

    if (coverageAmount == null || props.formState.termQuote == null) {
      setSkipInitialQuoteRun(false);
      return;
    }
    if (props.term30EnableTeaserRate) {
    setLoading(true);

    let isSubscribed = true;

    if (debounce) {
      clearTimeout(debounce);
    }

    debounce = setTimeout(() => runQuote(() => isSubscribed), 1000);

    return () => {
      clearTimeout(debounce);
      isSubscribed = false;
    };
   }
  }, [coverageAmount, props.formState.termQuote, props.formState.healthClass, activeTab]);

  const onSubmit = () => {
    const basicInfo = getBasicInfo();
    basicInfo.faceAmount = coverageAmount;
    basicInfo.termLength = props.formState.termQuote;
    setBasicInfo(basicInfo);
    const form = { ...props.fullFormState };
    form.pages.preQuote.coverageAmountQuote = coverageAmount;
    props.onMultiFieldChange(form);
    props.onNext();
  };

  const updateTermLength = (numberOfYears, trigger = true) => {
    // Set max at 30 and minimum at 5
    if (numberOfYears > 30) {
      numberOfYears = 30;
    } else if (numberOfYears < 5) {
      numberOfYears = 5;
    }

    // Set to ceil of nearest 10 (i.e. 17 rounds to 20)
    numberOfYears = Math.ceil(numberOfYears / 10) * 10;

    props.onFieldChange('termQuote', numberOfYears);
    props.formState.termQuote = numberOfYears;
  };

  useEffect(() => {
    const age = Age(props.basicInfo.birthdate);

    if (props.formState.termQuote === '') {
      const termLength = getTermLengthFromAge(age);
      props.onFieldChange('termQuote', termLength);
      props.formState.termQuote = termLength;
    }

    if (props.formState.coverageAmountQuote === '') {
     const coverageAmount = getFaceAmountFromAge(age);
      props.onFieldChange('coverageAmountQuote', coverageAmount);
      setCoverageAmount(coverageAmount);
    }
    }, [props.formState.termQuote, props.formState.coverageAmount]);

  useEffect(() => {
    if (calcHealthClass) {
      switch (calcHealthClass) {
        case "PP":
          setHealthClass(3);
          break;
        case "P":
          setHealthClass(2);
          break;
        default:
          setHealthClass(1);
          break;
      }
    }
  }, [calcHealthClass]);

  const redirect = () => {
    props.history.push('/term-insurance/select-appointment');
  };

  const handleHealthClassChange = (event) => {
    setCalcHealthClass(event);
  };

  return (
    <ThemeProvider theme={(theme) => createTheme({
      ...theme,
      ...quoterTheme,
    })}>
    {props.term30EnableTeaserRate &&
      <Container fluid className='top-header p-0'>
        <div className='coverage-header'>
          {!loading && lowestMonthlyQuote ?
            <Fragment>
              <span className="quote-title">Coverage as low as</span>
              <span className="quote-amount-dollars-container">
                                <NumberFormat
                                  className={`quote-amount-dollars-inner-term ${classes.amount}`}
                                  value={lowestMonthlyQuote}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                />
                                <span className={`quote-amount-mo`}> /mo</span>
                            </span>
            </Fragment> :
            loading ? <CircularProgress size={25}/> :
              <p className="message">We couldn't find results for your coverage amount and term length. Try another
                combination, or click "Contact a Specialist" to discuss your options.</p>

          }
        </div>

      </Container>
    }
      <Container className="p-0 outer-div-term">

        <div className="custom-info d-flex justify-content-center inner-div-term">
          <div className="pre-quote-form">
            <Row className="pre-quote-container mx-1">
              <Col lg={4} xs={12} sm={12} md={12}>
                <div className="bg-white block">
                  <Row className="text-center">
                    <Col className='section-wrap'>
                      <div className="section-group">
                        <div className="d-flex justify-content-center">
                          <div className={`icon-container ${classes.lightBackground}`}>
                            <SvgIcon component={ShieldIcon} color='primary'/>
                          </div>
                        </div>
                        <div className="card-title">Select Coverage Amount</div>
                        <Form.Group className='amount-div'>
                          <TextInput
                            name="coverageAmount"
                            id="coverageAmount"
                            value={coverageAmount}
                            onChange={(e) => {props.onFieldChange("coverageAmountQuote", parseInt(Number(e.target.value))); setCoverageAmount(parseInt(Number(e.target.value)));}}
                            variant="standard"
                            InputProps={{
                              inputComponent: NumberFormatDollars,
                              className: 'coverage-input',
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="coverage-slider">
                          <Slider
                            min={100000}
                            max={3000000}
                            step={50000}
                            value={coverageAmount}
                            onChange={(e, v) => {props.onFieldChange("coverageAmountQuote", v); setCoverageAmount(v);}}
                            className="coverage-amount"
                            marks={DigitalCoverageAmounts(false)}
                            role="slider"
                            aria-labelledby="coverageAmountQuote"
                          />
                        </Form.Group>

                        <p className={`tag-line ${classes.descBackground}`}>
                          Most financial experts recommend 10-15x your income plus your mortgage balance.
                        </p>
                      </div>
                      <div className="need-button-text">
                        <NeedsAnalysisButton
                          isPrequote={true}
                          title="HOW MUCH DO I NEED?"
                          setCoverageAmount={(face) => {props.onFieldChange("coverageAmountQuote", face); setCoverageAmount(face);}}
                          type="quote-screen"
                          isCustomTerm={true}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col lg={4} xs={12} sm={12} md={12} className='cursor-pointer'>
                <div className="bg-white block">
                  <Row className="text-center">
                    <Col className="section-wrap">
                      <div className="section-group">
                        <div className="d-flex justify-content-center">
                          <div className={`icon-container ${classes.lightBackground}`}>
                            <SvgIcon component={TimeIcon} color='primary'/>
                          </div>
                        </div>
                        <div className="card-title">Years of Coverage</div>
                        <Form.Group className="term-slider">
                          <div className='text-decor pt-0 pb-0'><span>{props.formState.termQuote}</span>
                            <span className='ml-1 inner-span'>Years</span>
                          </div>
                        </Form.Group>

                        <Form.Group className="coverage-slider">
                          <Slider
                            min={10}
                            max={30}
                            step={5}
                            value={props.formState.termQuote}
                            onChange={(e, v) => props.onFieldChange("termQuote", v)}
                            className="coverage-amount"
                            marks={ProductCoverageLength()}
                            role="slider"
                            aria-labelledby="termQuote"
                          />
                        </Form.Group>
                        <p className={`tag-line ${classes.descBackground}`}>Choose a term length that will cover your
                          longest financial commitment, such as a mortgage, loan, college funding or other financial
                          dependencies.</p>
                      </div>
                      <div className="term-length-button">
                        <TermLengthButton
                          isPrequote={true}
                          title="CHOOSE A TERM LENGTH"
                          type="quote-screen"
                          isCustomTerm={true}
                          onTermLengthCalculation={updateTermLength}
                          insuredAge={Age(props.basicInfo.birthdate)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col lg={4} xs={12} sm={12} md={12} className="cursor-pointer">
                <div className="bg-white block quote-rate">
                  <Row className="text-center">
                    <Col className='section-wrap'>
                      <div className="section-group">
                        <Row className="text-center">
                          <Col>

                            <div className="d-flex justify-content-center">
                              <div className={`icon-container ${classes.lightBackground}`}>
                                <SvgIcon component={DollarIMacIcon} color='primary'/>
                              </div>
                            </div>
                            <React.Fragment>
                              <div className="d-flex justify-content-center quote-amount-title">
                                <p className="card-title mb-0">Health Rating
                                </p>
                              </div>
                              <div className='pb-2'>
                                <h6><b>Select your Health Status</b></h6>
                              </div>
                            </React.Fragment>
                          </Col>
                        </Row>
                        <React.Fragment>
                          <Row className='justify-content-center'>
                            <Stepper activeStep={activeTab} alternativeLabel className='px-0'
                                     connector={<HealthClassStepperConnector/>}>
                              {steps.map((label, i) => (
                                <Step key={label.label} className='justify-content-center'>
                                  <StepLabel StepIconComponent={CustomStepIcon}
                                             onClick={() => setCalcHealthClass(label.healthValue)}>
                                    <Col xs={6}
                                         className={`w-100 icon-container ${activeTab === i + 1 ? classes.primaryBackground : classes.lightBackground} icon-margin`}>
                                      <SvgIcon component={label.icon} color='primary'/>
                                    </Col>
                                  </StepLabel>
                                </Step>
                              ))}
                            </Stepper>
                          </Row>
                          <div className="health-tag">
                            <h6 className='pt-1 pb-0 mb-0'><b>{steps[activeTab - 1].heading}</b></h6>
                            <p className='tag-line text-center'>{steps[activeTab - 1].description}</p>
                          </div>
                        </React.Fragment>
                      </div>

                      <div className="health-class-calc-button">
                        <HealthClassCalcButton
                          isPrequote={true}
                          title="HELP ME DECIDE"
                          type="quote-screen"
                          currentHealthClass={steps[activeTab - 1].heading}
                          onHealthClassChange={handleHealthClassChange}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row className="pre-quote-nav-control mt-4 px-1">
              <Col className="text-style-left" sm={12} md={6}>
                <Button variant="outlined" color="primary" className={`${classes.backButton} mb-2`} size="medium"
                        onClick={props.onBack}>BACK</Button>
              </Col>
              <Col className="text-style-right" sm={12} md={6}>
                <Button variant="contained" className='mb-2' size="medium" onClick={onSubmit} color="primary">SEE YOUR QUOTES</Button>
              </Col>
            </Row>
          </div>
        </div>
        <Row className='text-center justify-content-center align-items-center mt-5 pb-3'>
          <Col lg={7}>
            <h4><b>Need help?</b></h4>
            <p className='need-help-text'>A licensed insurance professional will help select the best coverage option
              for you. The quoting process is simple and the application typically takes 15 minutes to submit.</p>
            <Button variant="outlined" color="primary" className={classes.backButton} size="medium"
                    onClick={() => ContactSpecialist(props.fullFormState, coverageAmount, props.formState.termQuote, props.formState.healthClass, fullQuoteResults, redirect, props.onMultiFieldChange)}>CONTACT A SPECIALIST</Button>
          </Col>
        </Row>
      </Container>
    </ThemeProvider>
  );
}

PreQuote.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onMultiTerm: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  teaserRate: PropTypes.number,
  basicInfo: PropTypes.object,
  term30EnableTeaserRate: PropTypes.bool,
  fullFormState: PropTypes.object,
  onMultiFieldChange: PropTypes.func,
  history: PropTypes.object,

};

PreQuote.DefaultFormState = (prefill = false, teaserInfo = null, basicInfo = null) => {
  return {
    coverageAmountQuote: prefill ? 500000 : (basicInfo && basicInfo.faceAmount) || "",
    termQuote: prefill ? 20 : (basicInfo && basicInfo.termLength) || "",
    healthClass: prefill ? 'PP' : (basicInfo && basicInfo.healthClass) || 'PP',
  };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/steps/PreQuote.js